export const middlewareClientMapping = {
  authMiddleware: 'authMiddleware',
  clearAllAuthCookies: 'clearAllAuthCookies',
  inMapGoogleMiddleware: 'inMapGoogleMiddleware',
  parseGuestAuthUser: 'parseGuestAuthUser',
  validateReturnUrl: 'validateReturnUrl',
  verifyUserMiddleware: 'verifyUserMiddleware',
  validateForgotPasswordReset: 'validateForgotPasswordReset',
};
